import * as z from 'zod';

export const CreateUserSchema = z.object({
    name: z.string({
        message: 'Name is required!',
    }),
    //     .min(4, {
    //       message: 'Name at least 4 charecter!',
    //     }),
    email: z
        .string({
            message: 'Email is required!',
        })
        .email({
            message: 'Enter valid email!',
        }),
    password: z
        .string({
            message: 'Password is required!',
        })
        .min(6, {
            message: 'Password at least 4 charecter!',
        }),
    phone_number: z.string(),
    role_id: z.string({
        message: 'Role id is required!',
    }),
});
